module.exports = __webpack_public_path__ + "static/rollover_random-241b948f83ddbd744daf1d15523e3a44.svg";